import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { categories } from '../../mocks/categories';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/79bf140b8664cd53d26f5a13adc3721e.jpg"
            alt="Anaokulu İç Mekan"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>

        <div className="relative z-10 text-center px-6 w-full">
          <p className="text-white/90 text-lg md:text-xl font-light mb-4">Minikler için</p>
          <h1 className="text-5xl md:text-7xl font-display font-bold text-white mb-6 leading-tight">
            Hayal Edilen<br />Mobilyalar
          </h1>
          <p className="text-white/90 text-base md:text-lg font-light mb-10 max-w-2xl mx-auto">
            Montessori felsefesiyle tasarlanmış, İskandinav estetiğinde ahşap mobilyalar
          </p>
          <Link
            to="/urunler"
            className="inline-flex items-center gap-3 px-8 py-4 bg-coral text-white rounded-full text-base font-medium hover:bg-coral/90 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Ürünleri Keşfet
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-beige">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="relative h-[500px] rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=adorable%20little%20girl%204%20years%20old%20joyfully%20playing%20with%20colorful%20wooden%20Montessori%20toys%20in%20a%20warm%20cozy%20natural%20wood%20workshop%20atelier%20bright%20warm%20amber%20light%20wooden%20shelves%20full%20of%20handcrafted%20toys%20child%20enjoying%20creative%20play%20Scandinavian%20minimalist%20style%20soft%20pastel%20coral%20sage%20tones%20beautiful%20happy%20childhood&width=600&height=500&seq=about-girl-atolye-002&orientation=portrait"
                alt="Atölyemini Hikayesi"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div>
              <p className="text-sm text-warmGray mb-3">(Hikayemiz)</p>
              <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
                <span className="text-warmGray font-light">Atölyemini ile</span>
                <br />
                <span className="text-navy">Her Köşe Bir Macera</span>
              </h2>
              <p className="text-warmGray leading-relaxed mb-6">
                Atölyemini olarak, çocukların hayal güçlerini besleyen, güvenli ve estetik mobilyalar tasarlıyoruz. 
                Montessori felsefesinden ilham alan ürünlerimiz, İskandinav tasarım anlayışıyla buluşuyor.
              </p>
              <p className="text-warmGray leading-relaxed mb-6">
                Her bir ürünümüz, çocukların gelişimine katkı sağlayacak şekilde özenle tasarlanmış ve doğal ahşap 
                malzemelerden üretilmiştir. Anaokulları, okul öncesi kurumları ve oyun alanları için özel çözümler sunuyoruz.
              </p>
              <Link
                to="/hakkimizda"
                className="inline-flex items-center gap-2 text-coral font-medium hover:gap-4 transition-all whitespace-nowrap cursor-pointer"
              >
                Daha Fazla Bilgi
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-6">
            <div>
              <p className="text-4xl font-display italic text-warmGray mb-2">Ürün</p>
              <h2 className="text-5xl font-display font-bold text-navy">Kategorilerimiz</h2>
            </div>
            <p className="text-warmGray max-w-md">
              Anaokulları ve oyun alanları için özel tasarlanmış mobilya koleksiyonlarımız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {categories.slice(0, 3).map((category) => (
              <Link key={category.id} to={`/${category.slug}`} className="group cursor-pointer">
                <div className="relative h-[400px] rounded-2xl overflow-hidden mb-4">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="inline-block px-4 py-1.5 bg-mint rounded-full text-sm text-navy font-medium mb-3">
                  Kategori
                </div>
                <h3 className="text-2xl font-semibold text-navy group-hover:text-coral transition-colors">
                  {category.name}
                </h3>
              </Link>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/urunler"
              className="inline-flex items-center gap-2 px-8 py-3 bg-navy text-white rounded-full font-medium hover:bg-navy/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Tüm Ürünleri Gör
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-20 bg-beige">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <p className="text-sm text-warmGray mb-3">PROJELER</p>
            <h2 className="text-5xl font-display font-bold text-navy leading-tight max-w-3xl">
              Hayata Geçirdiğimiz<br />Hayal Mekanları
            </h2>
            <p className="text-warmGray mt-6 max-w-2xl">
              Türkiye genelinde 150'den fazla anaokulu, oyun kafesi ve çocuk aktivite merkezine mobilya çözümleri sunduk. 
              Her proje, çocukların gelişimine katkı sağlayan özel tasarımlarla hayata geçirildi.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative h-[400px] rounded-3xl overflow-hidden group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20Montessori%20kindergarten%20interior%20Istanbul%20natural%20wood%20tables%20chairs%20children%20learning%20playing%20bright%20colorful%20classroom%20educational%20wall%20art%20Scandinavian%20furniture%20safe%20environment%20spacious%20airy%20warm%20light&width=800&height=450&seq=proj-mikinadim-001&orientation=landscape"
                alt="Minik Adımlar Anaokulu"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-8 left-8">
                <h3 className="text-2xl font-semibold text-white mb-1">Minik Adımlar Anaokulu</h3>
                <p className="text-white/80">İstanbul</p>
              </div>
            </div>

            <div className="relative h-[400px] rounded-3xl overflow-hidden group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=cheerful%20children%20play%20cafe%20interior%20Ankara%20wooden%20play%20structures%20soft%20seating%20areas%20colorful%20wall%20decorations%20families%20enjoying%20space%20natural%20wood%20furniture%20bright%20windows%20happy%20atmosphere%20Montessori%20inspired&width=800&height=450&seq=proj-neseli-001&orientation=landscape"
                alt="Neşeli Çocuklar Oyun Kafesi"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-8 left-8">
                <h3 className="text-2xl font-semibold text-white mb-1">Neşeli Çocuklar Oyun Kafesi</h3>
                <p className="text-white/80">Ankara</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/projeler"
              className="inline-flex items-center gap-2 px-8 py-3 bg-navy text-white rounded-full font-medium hover:bg-navy/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Tüm Projeleri Gör
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Custom Design Section */}
      <section className="py-0 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="relative h-[600px] bg-beige overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=custom%20bespoke%20children%20kindergarten%20furniture%20design%20workshop%20natural%20wood%20artisan%20measuring%20sketching%20planning%20wood%20samples%20color%20palette%20warm%20workshop%20lighting%20craftsman%20creating%20unique%20Montessori%20piece&width=700&height=600&seq=custom-design-001&orientation=portrait"
                alt="Özel Tasarım"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-8 left-8">
                <p className="text-sm text-warmGray mb-2">Özel Çözümler</p>
              </div>
              <div className="absolute bottom-8 left-8">
                <h3 className="text-5xl font-display font-bold text-navy leading-tight">
                  Size Özel<br />Tasarım<br />Hizmeti
                </h3>
              </div>
            </div>

            <div className="bg-white flex items-center justify-center px-12 py-16">
              <div className="text-center max-w-md">
                <h3 className="text-4xl font-display font-bold text-navy mb-6 leading-tight">
                  Hayalinizdeki Mekanı<br />Birlikte Tasarlayalım
                </h3>
                <p className="text-warmGray leading-relaxed mb-8">
                  Her projenin kendine özgü ihtiyaçları vardır. Uzman ekibimiz, mekanınızın ölçülerine ve konseptinize 
                  uygun özel mobilya tasarımları oluşturur. Montessori felsefesi ve İskandinav estetiğini bir araya 
                  getirerek, çocukların gelişimine katkı sağlayan benzersiz alanlar yaratıyoruz.
                </p>
                <Link
                  to="/ozel-tasarim"
                  className="inline-flex items-center gap-3 px-8 py-4 bg-navy text-white rounded-full font-medium hover:bg-navy/90 transition-all whitespace-nowrap cursor-pointer"
                >
                  Ücretsiz Keşif Görüşmesi
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;